
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"48","height":"48","fill":"#31C783","rx":"4"}}),_c('path',{attrs:{"d":"M6 6h36v36H6z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M24 9c7.455 0 15 2.29 15 6.667v16.666C39 36.71 31.455 39 24 39S9 36.71 9 32.333V15.667C9 11.29 16.545 9 24 9zm-5.756 14.362h1.427C19.643 21.979 18.464 21 16.72 21c-1.718 0-3.01.967-3.005 2.414 0 1.175.835 1.85 2.182 2.198l.931.24c.883.223 1.467.5 1.47 1.135-.003.7-.667 1.167-1.634 1.167-.927 0-1.646-.416-1.706-1.275H13.5c.06 1.626 1.27 2.542 3.177 2.542 1.962 0 3.101-.98 3.105-2.422-.004-1.42-1.175-2.066-2.405-2.358l-.768-.192c-.671-.16-1.399-.444-1.39-1.127.003-.616.555-1.067 1.482-1.067.883 0 1.467.412 1.543 1.107zm10.17 1.842c0-2.645-1.614-4.204-3.76-4.204-2.15 0-3.76 1.559-3.76 4.204 0 2.642 1.61 4.205 3.76 4.205.52 0 1.007-.092 1.45-.268l.676.859h1.439l-1.135-1.455c.823-.72 1.33-1.858 1.33-3.34zm-4.263 1.343l1.107 1.455a2.291 2.291 0 0 1-.604.076c-1.33 0-2.27-1.011-2.27-2.874 0-1.862.94-2.873 2.27-2.873 1.335 0 2.27 1.01 2.27 2.873 0 1.007-.272 1.763-.735 2.246l-.696-.903h-1.342zm5.679 2.75h5.087v-1.243h-3.605v-6.942H29.83v8.185z"}})])])
          )
        }
      }
    